import React, { ReactElement, ReactNode } from 'react';
import { Modal, Sizes } from 'react-bootstrap';

export enum ModalType {
  CONFIRM = 'CONFIRM',
  CUSTOM_CONTENT = 'CUSTOM_CONTENT',
}

export interface ModalData {
  /**
   * Whether the modal should close when clicking on its backdrop.
   * @default true
   */
  closeOnHide?: boolean;
  type: ModalType;
  onHide?: () => void;
  errorMessage?: React.ReactNode;
}

export interface ModalProps {
  modalId: string;
  stackIndex: number;
  backdrop?: Modal.ModalProps['backdrop'];
}

export interface ConfirmModalProps {
  body: ReactElement | string;
  onConfirm?: Function;
  title: string;
  cancelLabel?: string;
  confirmLabel?: string;
  cancelColor?: string;
  confirmColor?: string;
  hideCancel?: boolean;
  onCancel?: Function;
  /**
   * Whether the modal should close when clicking on its backdrop.
   * @default true
   */
  closeOnHide?: boolean;
  onHide?: () => void;
  onConfirmAsync?: () => Promise<void>;
  /**
   * This will render inside an Alert with bsStyle="danger" component.
   */
  alertMessage?: ReactNode;
}

export interface ConfirmModalData extends ConfirmModalProps, ModalData {}

export interface CustomContentModalProps {
  customContent: ReactElement | string;
  id: string;
  size?: Sizes;
  title?: ReactElement | string;
  width?: number;
  backdrop?: Modal.ModalProps['backdrop'];
  /**
   * Whether the modal should close when clicking on its backdrop.
   * @default true
   */
  closeOnHide?: boolean;
  onHide?: () => void;
}

export interface CustomContentModalData
  extends CustomContentModalProps,
    ModalData {}

export interface ModalContextProps {
  modalId: string;
}
